import React from "react";
import { Modal } from "@tvg/design-system";
import { get } from "lodash";
import { getIsWagerCancellationRulesModalOpen } from "@tvg/sh-lib-my-bets/redux/selectors";
import { useSelector } from "react-redux";
import { ContentContainer } from "./styled-components";

interface WagerCancelationProps {
  isOpen: boolean;
  onClose: () => void;
  onBack?: () => void;
  userLocation: string;
  messages: {
    [key: string]: Array<{ text: string; title?: string }>;
  };
}

const WagerCancellationRulesModal = ({
  isOpen = false,
  onClose,
  messages,
  userLocation,
  onBack
}: WagerCancelationProps) => {
  const content = get(messages, userLocation, messages.DEFAULT);
  const { hasBack } = useSelector(getIsWagerCancellationRulesModalOpen);

  return (
    <>
      <Modal
        qaLabel="bet-cancel-rules"
        title="Wager cancellations"
        isOpen={isOpen}
        onAfterClose={onClose}
        onBack={hasBack ? onBack : undefined}
        hasBackgroundModal
      >
        <>
          {content &&
            content.length &&
            content.map(({ text }, index) => (
              <ContentContainer key={index.toString()}>{text}</ContentContainer>
            ))}
        </>
      </Modal>
    </>
  );
};

export default WagerCancellationRulesModal;
